export default __webpack_public_path__ + "static/Staatliches-Regular-5c0c08187bd8b181451477403c553a6a.woff";